import Dashboard from "layouts/dashboard";
import Home from "layouts/home";
import GoogleDashboard from "layouts/google-dashboard";
import YelpDashboard from "layouts/yelp-dashboard";
import FacebookDashboard from "layouts/facebook-dashboard";
import TwitterDashboard from "layouts/twitter-dashboard";
import Notifications from "layouts/notifications";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";

import OtpVerification from "layouts/authentication/OtpVerification";
import EmailVerification from "layouts/authentication/verify-email";
import EmailVerificationLanding from "layouts/authentication/verify-email/verify-email-landing";

import Chatbot from "layouts/Chatbot";
// @mui icons
import Icon from "@mui/material/Icon";
import ClientDetail from "layouts/authentication/ClientDetail";
import Protected from "./protectedRoutes";
import { CheckRoutes, CheckAuth } from "./restrictRoutes";
import ForgetPassword from "layouts/authentication/forget-password";
import NewPassword from "layouts/authentication/new-password";
import MyBusiness from "layouts/authentication/my-business";
import ViewBusiness from "layouts/authentication/ClientDetail/view-business";
import SocialInformation from "layouts/authentication/social-information";
import ThankYou from "layouts/authentication/thank-you";
import ScrapePage from "layouts/authentication/components/scrape-page";
import PrivacyPolicy from "layouts/authentication/components/PrivacyPolicy/PrivacyPolicy";
import TermsAndConditions from "layouts/authentication/components/termsCondition";
import BITabs from "components/BIButtom/BITabs";
import Landing from "layouts/LandingPage/Landing";
import BusinessInsight from "components/BIButtom/Business_Insight"

import Reviews from "layouts/authentication/request-reviews";
import ReviewDetail from "layouts/authentication/review-details";
import Redirect from "layouts/authentication/redirectPage/redirect";
import RedirectGeneric from "layouts/authentication/redirectGeneric";
import CompareMe from "components/BIButtom/Compare_Me";
import LocalIntelligence from "components/BIButtom/Local_Intelligence";
import TavloMoment from "components/BIButtom/Tavlo_Moment";
import Pricing from "layouts/home/Pricing";
import Contact from "layouts/home/Contact";
import About from "layouts/home/About";
import Insight from "layouts/home/Insight";
import Register from "layouts/authentication/sign-up/register";
import Login from "layouts/authentication/sign-in/Login";
import InsightContent from "layouts/home/BlogContent/InsightContent";
import Operationals from "layouts/home/BlogContent/Operationals";
import Customers from "layouts/home/BlogContent/Customers";
import ReviewsList from "layouts/authentication/request-reviews-list";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: (
      <CheckRoutes>
        {" "}
        <Dashboard />
      </CheckRoutes>
    ),
  },
  {
    type: "collapse",
    name: "yelp-dashboard",
    key: "yelp-dashboard",
    icon: <Icon fontSize="small">Yelp</Icon>,
    route: "/yelp-dashboard",
    component: (
      <CheckRoutes>
        {" "}
        <YelpDashboard />
      </CheckRoutes>
    ),
  },
  {
    type: "collapse",
    name: "Google",
    key: "google-dashboard",
    icon: <Icon fontSize="small">Google</Icon>,
    route: "/google-dashboard",
    component: (
      <CheckRoutes>
        {" "}
        <GoogleDashboard />
      </CheckRoutes>
    ),
  },
  {
    type: "collapse",
    name: "facebook-dashboard",
    key: "facebook-dashboard",
    icon: <Icon fontSize="small">Facebook</Icon>,
    route: "/facebook-dashboard",
    component: (
      <CheckRoutes>
        {" "}
        <FacebookDashboard />
      </CheckRoutes>
    ),
  },
  // {
  //   type: "collapse",
  //   name: "request-review",
  //   key: "request-review",
  //   icon: <Icon fontSize="small">Facebook</Icon>,
  //   route: "/request-reviews",
  //   component: (
  //     <CheckRoutes>
  //       {" "}
  //     <Reviews/>
  //     </CheckRoutes>
  //   ),
  // },
  {
    type: "collapse",
    name: "request-review",
    key: "request-review",
    icon: <Icon fontSize="small">Facebook</Icon>,
    route: "/request-reviews",
    component: (
      <CheckRoutes>
        {" "}
      <ReviewsList/>
      </CheckRoutes>
    ),
  },
  {
    type: "collapse",
    name: "x-dashboard",
    key: "x-dashboard",
    icon: <Icon fontSize="small">X</Icon>,
    route: "/x-dashboard",
    component: (
      <CheckRoutes>
        {" "}
        <TwitterDashboard />
      </CheckRoutes>
    ),
  },
  {
    type: "collapse",
    name: "home",
    key: "home",
    icon: <Icon fontSize="small">home</Icon>,
    route: "/",
    component: <Home />,
  },
  {
    type: "collapse",
    name: "Details",
    key: "details",
    icon: <Icon fontSize="small">Detail</Icon>,
    route: "/business-detail",
    component: (
      <Protected>
        {" "}
        <ClientDetail />
      </Protected>
    ),
  },
  {
    type: "collapse",
    name: "Details",
    key: "details",
    icon: <Icon fontSize="small">Detail</Icon>,
    route: "/review-details",
    component: (
      <Protected>
        {" "}
        <ReviewDetail/>
      </Protected>
    ),
  },

  {
    type: "collapse",
    name: "Notifications",
    key: "notifications",
    icon: <Icon fontSize="small">notifications</Icon>,
    route: "/notifications",
    component: <Notifications />,
  },
  {
    type: "collapse",
    name: "Profile",
    key: "profile",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/profile",
    component: (
      <Protected>
        {" "}
        <Profile />
      </Protected>
    ),
  },
  // {
  //   type: "collapse",
  //   name: "Sign In",
  //   key: "sign-in",
  //   icon: <Icon fontSize="small">login</Icon>,
  //   route: "/sign-in",
  //   component: (
  //     <CheckAuth>
  //       {" "}
  //       <SignIn />
  //     </CheckAuth>
  //   ),
  // },
  // {
  //   type: "collapse",
  //   name: "Sign Up",
  //   key: "sign-up",
  //   icon: <Icon fontSize="small">assignment</Icon>,
  //   route: "/sign-up",
  //   component: (
  //     <CheckAuth>
  //       {" "}
  //       <SignUp />
  //     </CheckAuth>
  //   ),
  // },
  {
    type: "collapse",
    name: "OTP Verification",
    key: "otp-verification",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/otp-verification",
    component: <OtpVerification />,
  },

  {
    type: "collapse",
    name: "email Verification",
    key: "email-verification",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/email-verification",
    component: <EmailVerification />,
  },
  {
    type: "collapse",
    name: "Landing Email Verification",
    key: "email-verification-landing",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/email-verification-landing",
    component: <EmailVerificationLanding/>,
  },
  {
    type: "collapse",
    name: "privacy policy",
    key: "privacy-policy",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/privacy-policy",
    component: <PrivacyPolicy />,
  },

  {
    type: "collapse",
    name: "terms condition",
    key: "terms-condition",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/terms-conditions",
    component: <TermsAndConditions />,
  },
  {
    type: "collapse",
    name: "Forget Password",
    key: "forget-password",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/forget-password",
    component: <ForgetPassword />,
  },
  {
    type: "collapse",
    name: "New Password",
    key: "new-password",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/new-password/:token",
    component: <NewPassword />,
  },
  {
    type: "collapse",
    name: "chatbot",
    key: "chatbot",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/chatbot",
    component: (
      <CheckRoutes>
        {" "}
        <Chatbot />
      </CheckRoutes>
    ),
  },

  {
    type: "collapse",
    name: "Social Information",
    key: "social-information",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/social-information",
    component: <SocialInformation />,
  },
  {
    type: "collapse",
    name: "my business",
    key: "my-business",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/my-business",
    component: (
      <Protected>
        {" "}
        <MyBusiness />
      </Protected>
    ),
  },

  {
    type: "collapse",
    name: "view business",
    key: "view-business",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/view-business",
    component: <ViewBusiness />,
  },
  {
    name: "Thank You",
    key: "thank-you",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/thank-you",
    component: <ThankYou />,
  },
  {
    name: "scrape page",
    key: "scrape-page",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/scrape-page",
    component: <ScrapePage />,
  },
  {
    type: "Business Intelligence",
    name: "Business Intelligence",
    key: "bi-tabs",
    icon: <Icon fontSize="small">bi-tabs</Icon>,
    route: "/business-intelligence",
    component: (
     <BITabs/>
    ),
  },
  {
    type: "Marketing Intelligence",
    name: "Marketing Intelligence",
    key: "bi-tabs",
    icon: <Icon fontSize="small">bi-tabs</Icon>,
    route: "/marketing-intelligence",
    component: (
     <BusinessInsight/>
    ),
  },
  {
    type: "Local Intelligence",
    name: "Local Intelligence",
    key: "bi-tabs",
    icon: <Icon fontSize="small">bi-tabs</Icon>,
    route: "/local-intelligence",
    component: (
     <LocalIntelligence/>
    ),
  },
  {
    type: "Compare Me",
    name: "Compare Me",
    key: "bi-tabs",
    icon: <Icon fontSize="small">bi-tabs</Icon>,
    route: "/compare-me",
    component: (
     <CompareMe/>
    ),
  },
  {
    type: "Tavlo Moments",
    name: "Tavlo Moments",
    key: "bi-tabs",
    icon: <Icon fontSize="small">bi-tabs</Icon>,
    route: "/tavlo-moments",
    component: (
     <TavloMoment/>
    ),
  },
  {
    type: "Landing",
    name: "Landing",
    key: "landing",
    icon: <Icon fontSize="small">landing</Icon>,
    route: "/landing",
    component: (
      <CheckAuth>
        <Landing />
      </CheckAuth>
    ),
  },
  {
    type: "Redirect",
    name: "Redirect",
    key: "redirect",
    icon: <Icon fontSize="small">redirect</Icon>,
    route: "/redirect",
    component: (
      <CheckAuth>
        <Redirect/>
      </CheckAuth>
    ),
  },
  {
    type: "RedirectGneric",
    name: "RedirectGeneric",
    key: "redirectGeneric",
    icon: <Icon fontSize="small">RedirectGneric</Icon>,
    route: "/redirect-generic",
    component: (
      <CheckAuth>
        <RedirectGeneric/>
      </CheckAuth>
    ),
  },


  {
    type: "Pricing",
    name: "Pricing",
    key: "Pricing",
    icon: <Icon fontSize="small">Pricing</Icon>,
    route: "/pricing",
    component: ( 
        <Pricing/> 
    ),
  },
   {
    type: "Contact Us",
    name: "Contact Us",
    key: "Contact Us",
    icon: <Icon fontSize="small">Contact Us</Icon>,
    route: "/contact",
    component: ( 
        <Contact/> 
    ),
  },
   {
    type: "About",
    name: "About",
    key: "About",
    icon: <Icon fontSize="small">About</Icon>,
    route: "/about",
    component: ( 
        <About/> 
    ),
  },
  {
    type: "Insight",
    name: "Insight",
    key: "Insight",
    icon: <Icon fontSize="small">Insight</Icon>,
    route: "/insight",
    component: ( 
        <Insight/> 
    ),
  },
  {
    type: "InsightContent",
    name: "InsightContent",
    key: "InsightContent",
    icon: <Icon fontSize="small">InsightContent</Icon>,
    route: "/insightContent",
    component: ( 
        <InsightContent/> 
    ),
  },
 {
    type: "Operationals",
    name: "Operationals",
    key: "Operationals",
    icon: <Icon fontSize="small">Operationals</Icon>,
    route: "/operational",
    component: ( 
        <Operationals/> 
    ),
  },
   {
    type: "Customers",
    name: "Customers",
    key: "Customers",
    icon: <Icon fontSize="small">Customers</Icon>,
    route: "/customer",
    component: ( 
        <Customers/> 
    ),
  },
   {
    type: "Register",
    name: "Register",
    key: "Register",
    icon: <Icon fontSize="small">Register</Icon>,
    route: "/sign-up",
    component: ( 
        <Register/> 
    ),
  },
   {
    type: "Login",
    name: "Login",
    key: "Login",
    icon: <Icon fontSize="small">Login</Icon>,
    route: "/sign-in",
    component: ( 
        <Login/> 
    ),
  },
];


export default routes;

